import React from 'react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { useLocale } from '@gov-nx/core/service';
import {
	useMojeSouborySeznamContext,
	useMyFilesDateRangeForm,
} from '@gov-nx/module/page';
import {
	Button,
	Dialog,
	DSGovFlex,
	FormDatePicker,
	FormWidthElementLayout,
	LayoutGap,
} from '@gov-nx/ui/web';

export const FilterFormModal = () => {
	const { code, myFilesFilters } = useMojeSouborySeznamContext();
	const { t } = useLocale(code);
	const { formDefinition, onSubmit } = useMyFilesDateRangeForm();

	return (
		<GovFormWeb
			formDefinition={formDefinition}
			onSubmit={onSubmit}>
			<Dialog
				isOpen={true}
				onClose={myFilesFilters.filterWindowOpened.setFalse}
				title={<h3>{t('formular.akce.filtrovat')}</h3>}
				footer={
					<>
						{(myFilesFilters.filter.datumVytvoreniOd ||
							myFilesFilters.filter.datumVytvoreniDo) && (
							<Button
								onClick={myFilesFilters.resetFilter}
								color="primary"
								type="outlined"
								aria-label={t('formular.akce.zrusit')}
								size="m"
								isExpandedMobile>
								{t('formular.akce.zrusit')}
							</Button>
						)}
						<Button
							aria-label={t('formular.akce.filtrovat')}
							name="submit"
							nativeType="submit"
							color="primary"
							size="m"
							type="solid"
							isExpandedMobile>
							{t('formular.akce.filtrovat')}
						</Button>
					</>
				}>
				<LayoutGap gap="m">
					<DSGovFlex gap="l">
						<FormWidthElementLayout>
							<FormDatePicker
								field={{
									name: 'datumVytvoreniOd',
								}}
								label={{
									children: t('formular.pole.obdobi-od'),
								}}
							/>
						</FormWidthElementLayout>
						<FormWidthElementLayout>
							<FormDatePicker
								field={{
									name: 'datumVytvoreniDo',
								}}
								label={{
									children: t('formular.pole.obdobi-do'),
								}}
							/>
						</FormWidthElementLayout>
					</DSGovFlex>
				</LayoutGap>
			</Dialog>
		</GovFormWeb>
	);
};
